import React from "react"
import "./VideoPlayer.scss"
import Player from "./Player.js"
import FeatherIcon from "feather-icons-react"

export default function VideoPlayer({toggleModal, videoPath}){
  return(
    <div className="videoPopup_container">
    <div className="videoPopup">
      <a
        onClick={() => toggleModal(false)}
        className="back_btn"
      >
        <FeatherIcon icon="x" size="34" color="#000" strokeWidth="2" />
      </a>
      <Player
        toggleModal={toggleModal}
        media={{
          video: videoPath
        }}
      />
    </div>
  </div>
  )
}